import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CreditCheck } from '../../../models';
import { TmsWebBaseService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class XeroService extends TmsWebBaseService {
  constructor() {
    super('XeroAccounts');
  }

  getInvoices(customerName: string): Observable<any> {
    return this.httpService.get<any>(`${this.apiUrl}/GetInvoices?customer=${customerName}`);
  }

  getCreditNotes(customerName: string): Observable<any> {
    return this.httpService.get<any>(`${this.apiUrl}/GetCreditNotes?customer=${customerName}`);
  }

  getPayments(customerName: string): Observable<any> {
    return this.httpService.get<any>(`${this.apiUrl}/GetPayments?customer=${customerName}`);
  }

  uploadAndEmailInvoice(id: string): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/UploadAndEmailInvoice/${id}`, {});
  }

  getCreditCheck(id: string): Observable<CreditCheck> {
    return this.httpService.get<CreditCheck>(`${this.apiUrl}/CustomerCreditCheck?id=${id}`);
  }

  postSalesInvoices(ids: string[]): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/CreateSalesInvoices`, { ids });
  }

  // Ask Xero for the paid status of the given invoices; the API stores Paid/DatePaid back
  // on each SalesInvoiceHeader, so the caller just reloads the grid afterwards.
  checkPaid(ids: string[]): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/CheckPaid`, { ids });
  }

  postCreditNotes(ids: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/CreateCreditNotes`, { ids });
  }

  postPurchaseInvoices(ids: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/CreatePurchaseInvoices`, { ids });
  }
}
